module.exports = __webpack_public_path__ + "static/media/A_iko_2_kontrast__hover.45e81b57.svg";